<template>
  <div>
    <h6 class="has-text-weight-bold mt-4 text-base text-gray-500">
      {{ value.label }}
    </h6>
    <div class="sm:col-span-2">
      <dd
        v-for="(file, index) in value.value"
        :key="index"
        class="mt-1 text-sm text-gray-900"
      >
        <PreviewUploadedFile :file="getMedia(file)"></PreviewUploadedFile>
      </dd>
    </div>
  </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import PreviewUploadedFile from '../../File/PreviewUploadedFile'

export default {
  name: 'PreviewFileUploadAttribute',
  props: ['value', 'medias'],
  components: {
    PreviewUploadedFile,
  },
  methods: {
    getMedia(id) {
      return this.medias.filter((media) => media.id == id)[0]
    },
  },
}
</script>

<style scoped></style>
